import React, { useEffect, useState } from "react";
import Bottom from "../assets/images/ComingSoon/Bottom.svg";
import Logo from "../assets/images/ComingSoon/logo.png"; // Import the logo image
import { useNavigate } from "react-router-dom";
import AnimatedTagline from "../animations/AnimatedTagLine";
import "../css/ComingSoonPage.css";

// Mail Icon SVG component
const MailIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="mail-icon-svg"
  >
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
  </svg>
);

// Arrow Right Icon SVG component
const ArrowRightIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="arrow-icon-svg"
  >
    <path d="M5 12h14" />
    <path d="m12 5 7 7-7 7" />
  </svg>
);

// Background Squares Component
const BackgroundSquares = () => {
  return (
    <div className="background-squares">
      {/* Left side square group */}
      <div className="left-squares">
        <div className="top-squares">
          <div className="square"></div>
          <div className="square"></div>
        </div>
        <div className="mid-squares">
          <div className="square"></div>
          <div className="square"></div>
        </div>
      </div>

      {/* Left bottom square */}
      <div className="left-bottom-square">
        <div className="square"></div>
      </div>

      {/* Center top square */}
      <div className="center-top-square">
        <div className="square green"></div>
      </div>

      {/* Right side squares */}
      <div className="right-squares">
        <div className="square purple"></div>
      </div>

      {/* Right middle squares */}
      <div className="right-mid-squares">
        <div className="square purple"></div>
        <div className="square purple"></div>
      </div>

      {/* Right bottom squares */}
      <div className="right-bottom-squares">
        <div className="square purple"></div>
        <div className="square purple bottom-right"></div>
      </div>
    </div>
  );
};

const ComingSoonPage = () => {
  const navigate = useNavigate();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Add Poppins font and handle resize events
  useEffect(() => {
    // Add Poppins font
    const link = document.createElement("link");
    link.href =
      "https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);

    // Handle resize
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      document.head.removeChild(link);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleNotifyClick = () => {
    navigate("/coming-soon-page-2");
  };

  const handleButtonHover = (e, isHovering) => {
    if (isHovering) {
      e.currentTarget.style.transform = "translateY(-5px)";
      e.currentTarget.style.boxShadow =
        "11px 25px 45px 0px rgba(0, 0, 0, 0.64)";
    } else {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.boxShadow =
        "11px 20px 40px 0px rgba(0, 0, 0, 0.64)";
    }
  };

  return (
    <div className="coming-soon-container">
      {/* Background elements */}
      {windowWidth >= 1024 && <BackgroundSquares />}

      {/* Main content section */}
      <div className="coming-soon-main-content">
        {/* Logo added above heading - properly centered */}
        <div className="logo-container">
          <img src={Logo} alt="Logo" className="logo-image" />
        </div>

        {/* Heading with outline effect */}
        <div className="heading-container">
          <h1 className="coming-soon-title">Coming Soon</h1>
        </div>

        {/* Animated tagline */}
        <div className="tagline-container">
          <AnimatedTagline />
        </div>

        {/* Notification button */}
        <div
          className="notify-button"
          onClick={handleNotifyClick}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              handleNotifyClick();
            }
          }}
          onMouseOver={(e) => handleButtonHover(e, true)}
          onMouseOut={(e) => handleButtonHover(e, false)}
        >
          <span className="mail-icon">
            <MailIcon />
          </span>
          <span className="notify-text">Get Notified When We Launch</span>
          <div className="arrow-container">
            <ArrowRightIcon />
          </div>
        </div>
      </div>

      {/* Bottom section containing both diagonal background and SVG */}
      <div className="bottom-section">
        {/* Green diagonal background - 5% taller than SVG */}
        <div className="diagonal-background">
          <div className="diagonal"></div>
        </div>

        {/* Bottom SVG image */}
        <div className="bottom-svg-container">
          <img src={Bottom} alt="Feature illustration" className="bottom-svg" />
        </div>
      </div>
    </div>
  );
};

export default ComingSoonPage;
